interface SpinnerProps {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function Spinner({ label = 'Loading...', size = 'md' }: SpinnerProps) {
  return <span className={`ui-spinner ui-spinner--${size}`} role="status" aria-label={label} aria-live="polite" />;
}
